import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';

const criteria = [
  {
    title: 'Attendance (≥ 90%)',
    desc: 'Students must maintain a minimum attendance of 90% throughout the training program, reflecting their dedication, consistency, and active participation in learning activities.',
  },
  {
    title: 'Technical Test Performance',
    desc: "Evaluation of students' understanding of technical concepts and subject knowledge through standardized technical assessments conducted before the start of the program.",
  },
  {
    title: 'Post-Training Assessment Marks',
    desc: 'Performance in the final assessment conducted upon completion of the training, measuring the overall learning outcomes and competency gained during the course.',
  },
  {
    title: 'Key Performance Indicator (KPI) Score',
    desc: 'Assessment of project work, assignments, practical application of concepts, participation, problem-solving abilities, and overall engagement throughout the program.',
  },
  {
    title: 'College/Trainer Remarks',
    desc: "Qualitative feedback provided by college representatives and trainers based on students' professionalism, discipline, attitude, teamwork, communication skills, and overall conduct during the training.",
  },
];

export default function SICInfoDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: { xs: '100%', sm: '90%', md: '1200px' },
          mx: { xs: 1, sm: 2, md: 'auto' },
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700, fontSize: { xs: '1rem', sm: '1.15rem' }, textAlign: 'center' }}>
        ABOUT SAMSUNG INNOVATION CAMPUS PROGRAMME
      </DialogTitle>

      <DialogContent dividers>
        {/* Intro bullets */}
        <List dense disablePadding sx={{ mb: 2 }}>
          {[
            <>The <strong>Samsung Innovation Campus (SIC) Programme</strong> is a global initiative of Samsung in running more than 40 countries.</>,
            <>It is an industry-academia initiative by <strong>Samsung</strong>, aimed at empowering students with emerging technologies skills that are essential for the digital economy.</>,
            <>The programme is focused on building industry-relevant expertise in emerging technologies to bridge the gap between academic knowledge and real-world industry requirements.</>,
          ].map((text, i) => (
            <ListItem key={i} alignItems="flex-start" sx={{ py: 0.5, pl: 0 }}>
              <ListItemText
                primary={<Typography variant="subtitle1">• {text}</Typography>}
              />
            </ListItem>
          ))}
        </List>

        {/* Courses Offered */}
        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          Courses Offered:
        </Typography>
        <List dense disablePadding sx={{ mb: 2 }}>
          {[
            'Artificial Intelligence (AI)'
          ].map((course) => (
            <ListItem key={course} sx={{ py: 0, pl: 0 }}>
              <ListItemText primary={<Typography variant="subtitle1">• {course}</Typography>} />
            </ListItem>
          ))}
        </List>

        {/* Topper Selection heading */}
        <Typography
          variant="body2"
          sx={{ fontWeight: 700, textAlign: 'center', mb: 1 }}
        >
          Samsung Innovation Campus – Topper Selection Criteria
        </Typography>

        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          The selection of Samsung Innovation Campus (SIC) Toppers is conducted through a comprehensive and merit-based evaluation process designed to recognize students who demonstrate exceptional commitment, technical proficiency, and overall performance throughout the program.
        </Typography>

        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          To ensure fairness and transparency, students are assessed against the following key criteria:
        </Typography>

        {/* Numbered criteria */}
        {criteria.map((item, idx) => (
          <Typography key={item.title} variant="body2" sx={{ mb: 1.5 }}>
            <strong>{idx + 1}. {item.title}</strong>
            <br />
            <Typography key={item.title} variant="subtitle1" sx={{ mb: 1.5 }}>
              {item.desc}
            </Typography>
          </Typography>
        ))}

        <Typography variant="subtitle1" sx={{ mt: 1 }}>
          The final topper selection is based on the cumulative performance across all the above parameters, ensuring that the chosen students not only excel academically but also demonstrate the commitment, discipline, and professional attributes essential for success in the technology industry.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ textTransform: 'none', minWidth: 80 }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
